import IReports from '../IReports'
import {
  API
} from 'aws-amplify'

class AWSReportsDataStore extends IReports {

  get = async () => {
    return new Promise((resolve, reject)=> {
      API.get('companies', '/companies/reports/object', {
        response: true,
        headers: {
          Accept: 'application/json',
        }
      })
      .then( (response) => {
        resolve(response.data)
      })
      .catch( (err) => {
        let res = {}
        if (err.response === undefined) {
          res = {status: '499', statusText: 'Internal Error', error: err}
          console.error('Error internal GET report: ', JSON.stringify(err))
        } else {
          res = {
            status: err.response.status,
            statusText: err.response.data,
            message: err.message
          }
          console.error('Error reponse GET report: ', JSON.stringify(res))
        }
        reject( new Error(res.message) )
      })
    })
  }

  retrieve() {
    return this.get()
  }
}

export default AWSReportsDataStore